import React from 'react';
import { useParams } from 'react-router-dom';
import { useSessionDetail } from './api';
import { LoadingState } from '../../components/common/LoadingState';
import { ApiErrorFallback } from '../../components/common/ApiErrorFallback';
import { ExerciseListItem } from './ExerciseListItem';

export function SessionDetailPage() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { data: session, isLoading, error, refetch } = useSessionDetail(sessionId || '');

  if (isLoading) {
    return <LoadingState message="Loading session details..." />;
  }

  if (error) {
    return <ApiErrorFallback error={error} onRetry={refetch} />;
  }

  if (!session) {
    return <div>Session not found.</div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Session Details</h1>
      <p className="text-muted-foreground mb-4">
        Session at {new Date(session.startTime).toLocaleString()}
      </p>
      
      <div className="border rounded-lg">
        <h2 className="text-lg font-semibold p-4 border-b">Exercises</h2>
        <div>
          {session.exercises.map((exercise, index) => (
            <ExerciseListItem key={exercise.id} exercise={exercise} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}